<div class="l-core-contents">
  <div class="l-wrap">
    <div
      [ngClass]="{
        'l-wrap__inner': !isDisabledWrapInner
      }"
    >
      <ng-content></ng-content>
    </div>
  </div>
</div>
